module.exports = __webpack_public_path__ + "static/media/chia_yin_chen.e1a8c114.jpg";